import { userRPO } from "user/repository"

export const resetPasswordDemand = async (email: string, captcha: string) => {
  await userRPO.resetPasswordDemand(email, captcha)
}

export const resetPassword = async (email: string, code: string, password: string, captcha: string) => {
  await userRPO.resetPassword(email, code, password, captcha)
}
